<template>
  <section class="pa-section pa-section-connection-app">
    <PodTypeSelector />
    <PodRoomSelector />
    <PodRoomCharacterList />
    <PodRoomNoPodView />
    <PodRoomListView />

    <PodRoomLeaveConfirmModal />
    <PodRoomBadgeCharacterListModal />
  </section>
</template>

<script>
import PodTypeSelector                from '@/components/Pages/Connections/ConnectionApp/components/PodTypeSelector.vue'
import PodRoomSelector                from '@/components/Pages/Connections/ConnectionApp/components/PodRoomSelector.vue'
import PodRoomCharacterList           from '@/components/Pages/Connections/ConnectionApp/components/PodRoomCharacterList.vue'
import PodRoomNoPodView               from '@/components/Pages/Connections/ConnectionApp/components/PodRoomNoPodView.vue'
import PodRoomListView                from '@/components/Pages/Connections/ConnectionApp/components/PodRoomListView/PodRoomListView.vue'
import PodRoomLeaveConfirmModal       from '@/components/Pages/Connections/ConnectionApp/components/PodRoomLeaveConfirmModal.vue'
import PodRoomBadgeCharacterListModal from '@/components/Pages/Connections/ConnectionApp/components/PodRoomBadgeCharacterListModal.vue'

export default {
  components : {
    PodTypeSelector,
    PodRoomSelector,
    PodRoomCharacterList,
    PodRoomNoPodView,
    PodRoomListView,
    PodRoomLeaveConfirmModal,
    PodRoomBadgeCharacterListModal
  },

  computed : {
    podRoomType(){
      return this.$store.state.connection.podRoomType;
    },

    podRoomId(){
      return this.$store.state.connection.podRoomId[this.podRoomType];
    }
  },

  data(){
    return {
      isMountedPage : false,
    };
  },

  watch : {
    isMountedPage(){
      this.setCreateButtonData();
    },

    podRoomId(){
      this.setCreateButtonData();
    }
  },

  methods : {
    setCreateButtonData(){
      if(this.isMountedPage === false) return;
      
      let isOpenButton = true;

      if(this.podRoomId === null){
        isOpenButton = false;
      }

      this.$store.dispatch({
        type        : 'createButton/updateCreateButton',
        isOpen      : isOpenButton,
        contentType : 'connection',
      });
    }
  },
  
  mounted(){
    this.$parent.$parent.$on('mountedPage', () => {
      this.isMountedPage = true;
    });
  },
  
  beforeDestroy(){
    this.$store.dispatch({
      type        : 'createButton/updateCreateButton',
      isOpen      : false
    });
  }
}
</script>

<style lang="scss">
@import "~bulma/sass/utilities/_all";

.pa-layout{
  .pa-main-contents-container-logined{
    .pa-section{
      &-connection-app{
        padding-top:0;
        margin-bottom:1.5rem;
      }
    }
  }
}
</style>